import React, { useContext } from 'react'

import Filter from './Filter'
import List from './List'
import Panel from '../panel/Panel'
import { AppStateContext } from '../../features/explorer/AppStateContext'
import DataContextProvider from './DataContextProvider'
import Header from './Header'

const Explorer = ({
    name,
    formName,
    DataContext,
    apiController,
    width,
    panelTitle,
    panelClassConfig
}) => {
    const {
        filterState,
        updateFilterState,
        syncFilterState,
        promotedRecords,
        togglePromotedRecords,
        toggleCollapsed,
        collapsedExplorers,
    } = useContext(AppStateContext)
    const filterExpanded = filterState[formName]
    const toggleFilter = updateFilterState.bind(this, formName)
    return (
        <Panel panelClassConfig={panelClassConfig(width)}>
            <div className="explorerWrapper">
                <DataContextProvider
                    name={name}
                    formName={formName}
                    apiController={apiController}
                    DataContext={DataContext}
                >
                    <Header
                        filterExpanded={filterExpanded}
                        toggleFilter={toggleFilter}
                        promotedRecords={promotedRecords[name]}
                        togglePromotedRecords={togglePromotedRecords}
                        toggleCollapsed={toggleCollapsed}
                        isCollapsed={collapsedExplorers[name]}
                        extraClass={`${formName}Header`}
                        name={name}
                        formName={formName}
                        panelTitle={panelTitle}
                    />
                    <Filter
                        width={width}
                        filterExpanded={filterExpanded}
                        isCollapsed={collapsedExplorers[name]}
                        syncFilterState={syncFilterState}
                        DataContext={DataContext}
                    />

                    <List
                        isCollapsed={collapsedExplorers[name]}
                        promotedRecords={promotedRecords}
                        filterExpanded={filterExpanded}
                        toggleFilter={toggleFilter}
                        DataContext={DataContext}
                    />
                </DataContextProvider>
            </div>
        </Panel>
    )
}

export default Explorer
